import axios from "axios";

export const fetchUsers = async (token) => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_ENDPOINT}/api/users-management/users`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
};

export const fetchPermits = async (token) => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_ENDPOINT}/api/users-management/permits`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
};

export const fetchRoles = async (token) => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_ENDPOINT}/api/users-management/roles`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
};

export const createUser = async ({ token, payload }) => {
  const { data } = await axios.post(
    `${process.env.REACT_APP_ENDPOINT}/api/users-management/users`,
    payload,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
};

export const updateUser = async ({ token, userId, payload }) => {
  const { data } = await axios.put(
    `${process.env.REACT_APP_ENDPOINT}/api/users-management/users/${userId}`,
    payload,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
};

export const deleteUser = async ({ token, userId }) => {
  const { data } = await axios.delete(
    `${process.env.REACT_APP_ENDPOINT}/api/users-management/users/${userId}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
};

export const resetPassword = async ({ token, userId }) => {
  const { data } = await axios.post(
    `${process.env.REACT_APP_ENDPOINT}/api/users-management/users/${userId}/reset-password`,
    {},
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
};
